import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'

@InputType()
export class RevokeLogisticDocumentLinksArgs extends ActionArgs {
  @Field(() => ID)
  logisticId: string
}

// TResult is the number of links revoked
export interface IRevokeLogisticDocumentLinks extends IAction<number, RevokeLogisticDocumentLinksArgs> {}
